import {typesMaterial} from "../TypeMaterial";

export const CompositionReplacementsFilterData = [
    {
        "idFromColumnFilter": "tempName",
        "id": "tempName",
    },
    {
        "idFromColumnFilter": "materialName",
        "id": "materialName",
    },
    {
        "idFromColumnFilter": "typeMaterial",
        "id": "typeMaterial",
        "filterFn": (value, filterValue) =>
            (typesMaterial[value] || value || "")
                .toString()
                .toLowerCase()
                .includes(filterValue.toLowerCase()),
    },
]
